import { render, staticRenderFns } from "./EvolutionLoginsTable.vue?vue&type=template&id=b4cc3f3c"
import script from "./EvolutionLoginsTable.vue?vue&type=script&lang=js"
export * from "./EvolutionLoginsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports